import store from 'store';

let promiseLock = false;

export async function fetchDataForRoutePrams (routeParams) {
  const prevAccountId = store.getters['accounts/currentAccountId'];
  await store.dispatch('common/SET_ROUTE_PARAMS', routeParams);

  const doNotCacheAccount = store.getters['accounts/clearAccountsCacheFlag'];

  await store.dispatch('accounts/SET_CURRENT_ACCOUNT_ID', parseInt(routeParams.accountId) || null);

  // do not fetch user role and permissions if account is not changed (it depends only on account)
  if (doNotCacheAccount || prevAccountId !== parseInt(routeParams.accountId)) {
    await Promise.all([
      await store.dispatch('user/FETCH_USER_ROLE'),
      await store.dispatch('user/FETCH_USER_PERMISSIONS')
    ]);
  }

  store.dispatch('accounts/FETCH_AORI_USER_BALANCE', parseInt(routeParams.accountId) || null);

  await Promise.all(
    [
      store.dispatch('projects/SET_CURRENT_PROJECT_ID', parseInt(routeParams.projectId) || null).then(
        () => store.dispatch('bidmanager/SET_CURRENT_BIDMANAGER_GROUP_ID', parseInt(routeParams.bidManagerGroupId || null))
      ),
      store.dispatch('placements/SET_CURRENT_PLACEMENT_ID', parseInt(routeParams.placementId) || null),
      store.dispatch('connections/SET_CURRENT_CONNECTION_ID', parseInt(routeParams.connectionId) || null),
      store.dispatch('orders_old/SET_CURRENT_ORDER_ID', parseInt(routeParams.orderId) || null),
      store.dispatch('contract/SET_CURRENT_CONTRACT_ID', parseInt(routeParams.contractId) || null)
    ]
  );
}

export default async function fetchStoreData (route) {
  const routeParams = route.params;

  if (promiseLock) {
    try {
      await promiseLock;
    } catch (e) {
      console.warn(`Promise failed with error [${e}]. Ignoring`);
    }
  }

  // save params to store for backbone views
  try {
    promiseLock = fetchDataForRoutePrams(routeParams);
    await promiseLock;
  } catch (e) {

    // clear promise if error happened
    promiseLock = null;
    throw e;
  }

  // set current route to store to support saving route while navigating in sidebar
  if (routeParams.projectId) {
    store.dispatch('routing/SET_CURRENT_PROJECT_ROUTE', route);
  } else if (routeParams.accountId) {
    store.dispatch('routing/SET_CURRENT_ACCOUNT_ROUTE', route);
  }
  store.dispatch('routing/SET_CURRENT_ROUTE', route);
}
